export const formatMontoCop = (value) => {
    if (!value) return ""; // Si no hay valor, retorna vacío

    // Formatea el número con puntos cada tres dígitos y agrega el signo $
    return `$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};
